<template lang="pug">
  .page.page_offset_top.page_offset_bottom
    .page-meta
      .container
        .page-meta__inner.page-meta__inner_top
          breadcrumbs
          social.page-meta__social-list(theme="blue")
    .page-mediacenter
      .container
        .page-mediacenter__container
          h1.title.title_size_l.text_center.page-mediacenter__title Медиацентр
          p.text_theme_gray.text_center.page-mediacenter__desc We’re happy to&nbsp;answer any questions you may have, just send&nbsp;us a&nbsp;message via our in-app support chat.
          .jumbotron.page-mediacenter__jumbotron
            .jumbotron__image
              img(src="/static/img/about-bg.jpg", alt="")
            .jumbotron__content
              h2.title.title_size_m.jumbotron__title О компании
              p.text.text_theme_gray BelkaCar — это компания, предоставляющая сервис, который позволяет людям находить рядом с собой доступные автомобили и арендовать их через мобильное приложение, причём очень быстро, удобно и недорого. Компания основана в 2015 году Екатериной Макаровой, Лорианой Сардар и Еленой Мурадовой, вместе получившими MBA в Калифорнийском государственном университете. С первого дня запуска сервиса компания выставила 100 автомобилей в Москве.
          router-link.btn.btn_theme_dark-blue.btn_size_xl.btn_center(to="/mediacenter/about") Подробнее
    section.news-preview-section
      .container
        .page-mediacenter__container
          h2.title.title_size_l.text_center.news-preview-section__title Последние новости
          .news-card-list.news-preview-section__news-card-list
            router-link.news-card-item.news-card-item_single(to="/mediacenter/news/news-inner")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title BelkaCar начинает работать в Сочи
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack …
              .news-card-item__image
                img(src="/static/img/news-1.jpg", alt="")

            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-2.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми KIA Rio X-Line
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack Основатели крупнейшего российского каршеринга

            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-3.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12
          router-link.btn.btn_theme_dark-blue.btn_size_xl.btn_center(to="/mediacenter/news") Больше новостей
    section.brand-section
      .container
        .page-mediacenter__container
          h2.title.title_size_l.text_center.brand-section__title Наш бренд
          .brand-card-list
            .brand-card-item
              img(src="/static/img/brand-1.jpg", alt="")
              .brand-card-item__cover
                a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
            .brand-card-item.brand-card-item_square
              img(src="/static/img/brand-2.jpg", alt="")
              .brand-card-item__cover
                a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
            .brand-card-item.brand-card-item_square
              img(src="/static/img/brand-3.jpg", alt="")
              .brand-card-item__cover
                a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
            .brand-card-item
              img(src="/static/img/brand-4.jpg", alt="")
              .brand-card-item__cover
                a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать

          router-link.btn.btn_theme_dark-blue.btn_size_xl.btn_center(to="/mediacenter/brand") Перейти

    section.contacts-pressa-section
      .container
        .page-mediacenter__container
          h2.title.title_size_l.text_center.contacts-pressa-section__title Контакты для прессы
          .contacts-pressa-section__row
            .contacts-pressa-section__col
              h3.contacts-pressa-section__name Екатерина Макарова
              p.contacts-pressa-section__contacts
                a(href="tel:+7 (903) 191-34-85") +7 (903) 191-34-85
                a(href="mailto:emakarova@belkacar.ru") emakarova@belkacar.ru
            .contacts-pressa-section__col
              h3.contacts-pressa-section__name Алексей Скорик
              p.contacts-pressa-section__contacts
                a(href="tel:+7 (903) 191-34-85") +7 (962) 933-30-99
                a(href="mailto:emakarova@belkacar.ru") skorik@vincipr.com

</template>

<script>
import Social from './../components/Social'

export default {
  name: 'MediaCenter',
  components: { Social },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MediaCenter.vue